module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_8019.30ddb497.png";